import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

import Logo from "../../../assets/logos/18.svg"

const colorConfig = {
  brand: "hsl(28, 100%, 60%)",
  textDark: "hsl(210, 8%, 45%)",
  textLight: "white",
  hamburgerDark: "hsl(210, 10%, 20%)",
  hamburgerLight: "white",
};

const pageColorThemes = {
  "/": "dark",
  "/how-it-works": "light",
  "/sellers": "light",
  "/community": "light",
  "/support": "dark",
  "/contact":"light"
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();

  const currentTheme = pageColorThemes[location.pathname] || "dark";

  const navLinks = [
    { name: "Home", to: "/" },
    { name: "How It Works", to: "/how-it-works" },
    { name: "For Sellers", to: "/sellers" },
    { name: "For Communities", to: "/community" },
    { name: "Support", to: "/support" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const brandNameStyle = {
    color:
      scrolled || currentTheme === "dark"
        ? colorConfig.brand
        : colorConfig.textLight,
  };

  const hamburgerStyle = {
    "--hamburger-color":
      isMenuOpen || scrolled || currentTheme === "dark"
        ? colorConfig.hamburgerDark
        : colorConfig.hamburgerLight,
  };

  const headerClasses = `main-header ${scrolled ? "scrolled" : ""} ${
    isMenuOpen ? "menu-open" : ""
  }`;

  const flag =
    location.pathname === "/privacy-policy" ||
    location.pathname === "/terms-and-conditions";
  console.log(location.pathname, "pathname", flag);

  return (
    <header
      className={headerClasses}
  style={{
          position: flag && "static",
        }}
    >
      <div
        className="header-container"
      
      >
        <NavLink to="/" className="brand-section" aria-label="Vanijyan Home">

        <img src={Logo} className="_brandLogo_q0A_" /> {/* Apply the new class here */}

          <span className="brand-name" style={brandNameStyle}>
            Vanidya
          </span>

          
        </NavLink>

        <nav
          className={`main-nav ${isMenuOpen ? "nav-open" : ""}`}
          role="navigation"
        >
          <ul className="nav-list">
            {navLinks.map((link, index) => (
              <li
                key={link.name}
                className="nav-item"
                style={{ animationDelay: `${isMenuOpen ? index * 100 : 0}ms` }}
              >
                <NavLink
                  to={link.to}
                  style={({ isActive }) => {
                    if (isActive) {
                      return { color: colorConfig.brand };
                    }

                    if (scrolled) {
                      return { color: colorConfig.textDark };
                    }

                    if (isMenuOpen) {
                      return { color: colorConfig.textDark };
                    }

                    return {
                      color:
                        currentTheme === "light"
                          ? colorConfig.textLight
                          : colorConfig.textDark,
                    };
                  }}
                  className="nav-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="cta-section">
          <button
            onClick={() => navigate("/get-app")}
            className="get-app-button"
          >
            Get the App
          </button>
        </div>

        <button
          className={`hamburger-menu ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          style={hamburgerStyle}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
